import type { FilterRuleModel } from '@/shared/generated'

import { StopListFieldsCard } from '@/widgets/scenario-stoplist'

import { SettingsTemplateType } from '@/shared/generated'

import { useScenarioSettingActions } from '../lib/useScenarioSettingActions'
import { useScenarioItemContext } from './ScenarioItemProvider'

export const ScenarioItemStopList = ({
	prefix,
	skuRules,
}: {
	prefix?: string
	skuRules?: FilterRuleModel[]
}) => {
	const { scenario } = useScenarioItemContext()
	const actions = useScenarioSettingActions({
		templateType: SettingsTemplateType.ScenarioBusinessConstraints,
	})

	return (
		<StopListFieldsCard
			prefix={prefix}
			scenarioId={scenario?.id}
			actions={actions}
			skuRules={skuRules}
		/>
	)
}
